import ContactForm from "components/EmbeddedForm/ContactForm"
import PortableText from "components/PortableText"
import PortableTitle from "components/shared/PortableTitle"
import { useSizing } from "lib/helpers"
import { ContactHeader, Form } from "schemas"
import { Container, Grid, HStack, styled, VStack } from "styled-system/jsx"
import { vstack } from "styled-system/patterns"

type Props = ContactHeader

function Columns({
  title,
  body,
  featuresTitle,
  features,
  customForm,
  cta,

  sizingTop,
  sizingBottom,
}: Props) {
  return (
    <styled.div
      className="landingHeader"
      style={
        {
          "--pt": useSizing(sizingTop) || "80px",
          "--pb": useSizing(sizingBottom) || "80px",
        } as React.CSSProperties
      }
      css={{
        pt: "var(--pt)",
        pb: "var(--pb)",
        // mt: "-120px",
        bg: "#000A3A",
        color: "#F2F2F5",
      }}>
      <Container>
        <Grid
          columns={{ lg: 2 }}
          gap="100px"
          gridTemplateColumns={{ xl: "1fr 1.15fr" }}
          alignItems="start">
          <VStack
            gap={5}
            alignItems="start"
            css={{
              maxW: "650px",
              margin: "auto",
              width: "100%",
            }}>
            <PortableTitle
              as="h1"
              css={{
                color: "#F2F2F5",
                fontFamily: "heading",
                fontSize: { base: "32px", lg: "36px" },
                fontStyle: "normal",
                fontWeight: 600,
                lineHeight: "146%",

                "& em": {
                  background:
                    "linear-gradient(270deg, #DAA6FB 0%, rgba(218, 166, 251, 0.00) 94.48%)",
                  borderRadius: "0 50px 50px 0",
                  lineHeight: "46px",
                  boxDecorationBreak: "clone",
                  px: "6px",
                  py: "1px",
                  // my: "-1px",
                  mx: "-6px",
                },
              }}>
              {title}
            </PortableTitle>
            <styled.div
              css={{
                color: "#F2F2F5",
                fontFamily: "heading",
                fontSize: "20px",
                fontWeight: 600,
                lineHeight: "136%",
                mb: 7,
              }}>
              <PortableText
                className={vstack({
                  gap: 3,
                })}
                value={body}
              />
            </styled.div>
            {featuresTitle && features && features.length > 0 && (
              <VStack alignItems="start" gap={4}>
                <styled.p
                  css={{
                    color: "#F2F2F5",
                    fontSize: "24px",
                    fontStyle: "normal",
                    fontWeight: 700,
                    lineHeight: "133%",
                  }}>
                  {featuresTitle}
                </styled.p>

                <VStack
                  alignItems="start"
                  gap={2}
                  css={{
                    color: "#B5B5FF",
                    fontSize: "20px",
                    lineHeight: "157%",
                  }}>
                  {features.map((feature, i) => (
                    <FeatureListItem key={feature + i}>
                      {feature}
                    </FeatureListItem>
                  ))}
                </VStack>
              </VStack>
            )}
          </VStack>
          <styled.div
            css={{
              color: "primary.1",
              margin: "auto",
              width: "100%",
              maxW: "650px",
              rounded: "20px",
              padding: "40px 32px",
              background: "#F5F7FF",
            }}>
            <ContactForm customForm={customForm as Form} />
          </styled.div>
        </Grid>
      </Container>
    </styled.div>
  )
}

const FeatureListItem = ({ children }) => (
  <HStack alignItems="start" gap={1}>
    <styled.svg
      m={1}
      flex="0"
      minW="max-content"
      hideBelow="lg"
      xmlns="http://www.w3.org/2000/svg"
      width="17px"
      height="17px"
      viewBox="0 0 17 17"
      fill="none">
      <rect width="17" height="17" rx="8.5" fill="#1CD6B5" />
      <path
        d="M7.02474 11.8167C6.87159 11.8167 6.73121 11.7657 6.61634 11.6508L4.07659 9.11108C3.84687 8.88135 3.84687 8.524 4.07659 8.29428C4.30632 8.06455 4.66367 8.06455 4.8934 8.29428L7.03751 10.4256L12.1298 5.34612C12.3595 5.1164 12.7169 5.1164 12.9466 5.34612C13.1763 5.57585 13.1763 5.9332 12.9466 6.16293L7.44591 11.6508C7.31828 11.7657 7.1779 11.8167 7.02474 11.8167Z"
        fill="white"
      />
    </styled.svg>
    <styled.svg
      m={1}
      minW="max-content"
      hideFrom="lg"
      xmlns="http://www.w3.org/2000/svg"
      width="10px"
      height="11px"
      viewBox="0 0 10 11"
      fill="none">
      <rect
        x="0.753906"
        y="0.356689"
        width="9.08219"
        height="9.08219"
        rx="4.5411"
        fill="#1CD6B5"
      />
      <path
        d="M4.5167 6.66932C4.43488 6.66932 4.35988 6.64204 4.29851 6.58068L2.94166 5.22382C2.81893 5.10109 2.81893 4.91018 2.94166 4.78745C3.06439 4.66472 3.2553 4.66472 3.37803 4.78745L4.52352 5.92612L7.24404 3.21241C7.36677 3.08968 7.55769 3.08968 7.68042 3.21241C7.80315 3.33514 7.80315 3.52605 7.68042 3.64878L4.7417 6.58068C4.67352 6.64204 4.59852 6.66932 4.5167 6.66932Z"
        fill="white"
      />
    </styled.svg>
    <p>{children}</p>
  </HStack>
)

export default Columns
export type { Props as ContactHeaderProps }
